__webpack_require__.p = "https://kiosk-santa-rosa.mercywellness.com/_next/";